var exports = {
  "WB": "DMWelcomeSection.module__welcomeSection___VDMxM2",
  "rZ": "DMWelcomeSection.module__profileSection___VDMxM2",
  "KI": "DMWelcomeSection.module__avatarButton___VDMxM2",
  "xO": "DMWelcomeSection.module__usernameButton___VDMxM2",
  "Xh": "DMWelcomeSection.module__username___VDMxM2",
  "Yh": "DMWelcomeSection.module__welcomeText___VDMxM2",
  "A2": "DMWelcomeSection.module__actionSection___VDMxM2",
  "I9": "DMWelcomeSection.module__mutualGuildsContainer___VDMxM2",
  "Ko": "DMWelcomeSection.module__guildIconWrapper___VDMxM2",
  "$f": "DMWelcomeSection.module__guildIcon___VDMxM2",
  "Ii": "DMWelcomeSection.module__mutualGuildsText___VDMxM2",
  "fc": "DMWelcomeSection.module__actionButtonsContainer___VDMxM2",
  "a1": "DMWelcomeSection.module__userTag___VDMxM2",
};

module.exports = exports;
